const RamciStatusEnum = {
  PROCESSING: 1,
  REJECTED: 2,
  SUCCESSFUL: 3,
};

export default RamciStatusEnum;
